<template>
	<b-navbar toggleable="md" type="light">

		<b-navbar-toggle v-if="loggedInEmail" target="nav_collapse"></b-navbar-toggle>

		<b-navbar-brand>
			<img src="/static/img/levelfi.png" class="main-logo" alt="LevelFi">
			<p class="powered-by-liftfund-text">Powered by Liftfund</p>
		</b-navbar-brand>


		<b-collapse v-if="loggedInEmail" is-nav id="nav_collapse">

			<b-navbar-nav class="ml-">
				<b-nav-item to="/upload">Single Upload</b-nav-item>
				<b-nav-item to="/batch">Batch Upload</b-nav-item>
				<b-nav-item to="/about">About</b-nav-item>
			</b-navbar-nav>

			<!-- Right aligned nav items -->
			<b-navbar-nav class="ml-auto">

				<b-nav-item-dropdown right>
					<!-- Using button-content slot -->
					<template slot="button-content">
						{{loggedInEmail}}
					</template>
					<b-dropdown-item to="/myaccount">Account</b-dropdown-item>
					<b-dropdown-item @click="signout()">Sign Out</b-dropdown-item>
				</b-nav-item-dropdown>
			</b-navbar-nav>

		</b-collapse>
	</b-navbar>
</template>
<script>
import API from "@/services/api";

export default {
  data() {
    return {};
  },
  subscriptions: {
    loggedInEmail: API.LoggedInEmail
  },
  methods: {
    signout() {
      API.Logout();
      this.$router.push("/login");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #c8d9e9;
}
.main-logo {
  width: 144px;
  height: 40px;
}

.powered-by-liftfund-text { 
 font-size: .8em;
 color: rgb(73, 73, 73);
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue